/*global jQuery*/
/**
 * {{name}}
 * Global JS
 *
 * version: {{version}}
 * file:    {{file}}
 * author:  Arkadiusz Chatys <achatys@squiz.pl>
 * change log:
 *     {{date}} - First revision
 */

/*
 * Table of Contents
 *
 * - Global
 * - Modules
{{toc}}
 */
"use strict";
/*
--------------------
Global
--------------------
*/
//  Declare JS Enabled.
document.querySelector("body").classList.remove("no-js");

/**
 * @description - Function  returns information wether given DOM element is currently in the viewport (with additional offset).
 * @param {DOM element} elem - pass DOM element
 */
const isInViewport = elem => {
  const bounding = elem.getBoundingClientRect();

  return (
    bounding.top <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.left >= 0 &&
    bounding.bottom >=
      (window.innerHeight || document.documentElement.clientHeight) - 400 &&
    bounding.right <=
      (window.innerWidth || document.documentElement.clientWidth) + 10
  );
};

/*eslint no-unused-vars: 0*/
// Source: http://davidwalsh.name/javascript-debounce-function
function debounce(func, wait) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      timeout = null;
      func.apply(context, args);
    }, wait);
  };
}

/**
 * @description Polyfill for forEach on IE11
 */
(function() {
  if (!Array.prototype.forEach) {
    Array.prototype.forEach = function(fn, scope) {
      for (var i = 0, len = this.length; i < len; ++i) {
        fn.call(scope, this[i], i, this);
      }
    };
  }

  if (!Array.from) {
    Array.from = function(object) {
      "use strict";
      return [].slice.call(object);
    };
  }
})();

// 'use strict';

(function () {
    var body = document.body;
    var burgerMenu = document.getElementsByClassName('b-menu')[0];
    var burgerContain = document.getElementsByClassName('b-container')[0];
    var burgerNav = document.getElementsByClassName('b-nav')[0];

    burgerMenu.addEventListener('click', function toggleClasses() {
        [body, burgerContain, burgerNav].forEach(function (el) {
            el.classList.toggle('open');
        });
    }, false);
})();

/**
 * @description - Fallback for older browsers when using object-fit: cover
 *
 * To use it apply class .object-fit-fallback to wrapper of an image you want to make fallback for
 */
if (!Modernizr["object-fit"]) {
  Array.from(document.querySelectorAll(".object-fit-fallback")).forEach(
    item => {
      var container = item,
        imgUrl = container.querySelector("img").getAttribute("src");
      if (imgUrl) {
        container.setAttribute("style", `background-image: url('${imgUrl}')`);
        container.classList.add("compat-object-fit");
      }
    }
  );
}

/*
--------------------
Modules
--------------------
*/
